const PENDING_COUNT_EVENT = "maqmailing:unassigned-pending-count";

export function emitUnassignedPendingCount(pendingCount) {
  if (typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent(PENDING_COUNT_EVENT, { detail: pendingCount }),
  );
}

export function subscribeToUnassignedPendingCount(listener) {
  if (typeof window === "undefined") return () => {};

  const handleEvent = (event) => listener(event.detail);
  window.addEventListener(PENDING_COUNT_EVENT, handleEvent);
  return () => window.removeEventListener(PENDING_COUNT_EVENT, handleEvent);
}
